import { render, staticRenderFns } from "./AppointmentListItemPlaceholder.vue?vue&type=template&id=0cddd7e7&scoped=true"
import script from "./AppointmentListItemPlaceholder.vue?vue&type=script&lang=js"
export * from "./AppointmentListItemPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./AppointmentListItemPlaceholder.vue?vue&type=style&index=0&id=0cddd7e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddd7e7",
  null
  
)

export default component.exports